import { HTTP } from "./http";

export const RateService = {
  like(id, value) {
    return HTTP.put(`rate/${id}/like`, {
      value,
    });
  },
};
